import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import Logo from '../components/Logo';
import { ROUTES } from '../config/routes';

const LandingPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-navy-950 via-navy-900 to-navy-800">
      <header className="border-b border-navy-700 bg-navy-950/80">
        <div className="mx-auto flex max-w-7xl items-center justify-center px-5 py-4 sm:px-8">
          <Logo size="sm" />
        </div>
      </header>

      <main>
        <section className="mx-auto max-w-7xl px-5 py-20 text-center sm:px-8 sm:py-28">
          <div className="mx-auto max-w-3xl">
            <p className="mb-4 text-sm font-semibold uppercase tracking-[0.18em] text-gold-400">
              Workplace alertness checks
            </p>
            <h1 className="text-4xl font-bold leading-tight text-white sm:text-5xl md:text-6xl">
              A clearer view of fatigue and alertness at work.
            </h1>
            <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-navy-200 sm:text-lg">
              Use brief reaction-time assessments to monitor alertness and review results across your team.
            </p>
            <div className="mt-9 flex flex-col justify-center gap-3 sm:flex-row">
              <Button
                onClick={() => navigate(ROUTES.LOGIN)}
                className="min-h-11 bg-gold-500 text-navy-950 hover:bg-gold-400"
              >
                Sign in
              </Button>
              <Button
                variant="outline"
                onClick={() => navigate(ROUTES.GUEST.INFO)}
                className="min-h-11 border-navy-500 text-white hover:bg-navy-800"
              >
                Try a guest check
              </Button>
            </div>
          </div>
        </section>

        <section className="border-y border-navy-700 bg-navy-900/70 px-5 py-14 sm:px-8">
          <div className="mx-auto max-w-5xl">
            <h2 className="text-center text-2xl font-semibold text-white sm:text-3xl">How it works</h2>
            <ol className="mt-8 grid gap-4 md:grid-cols-3">
              {[
                ['01', 'Set up a check', 'Choose a test length and enter the required participant details.'],
                ['02', 'Respond to the cues', 'Follow the on-screen instructions and respond when prompted.'],
                ['03', 'Review the results', 'See a clear summary of reaction times, lapses, and false starts.'],
              ].map(([number, title, description]) => (
                <li key={number} className="rounded-xl border border-navy-700 bg-navy-800 p-6">
                  <span className="text-sm font-bold text-gold-400">{number}</span>
                  <h3 className="mt-3 text-lg font-semibold text-white">{title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-navy-200">{description}</p>
                </li>
              ))}
            </ol>
          </div>
        </section>
      </main>

      <footer className="mx-auto flex max-w-7xl flex-col gap-3 px-5 py-8 text-sm text-navy-300 sm:flex-row sm:items-center sm:justify-between sm:px-8">
        <span>© 2026 Vigikus</span>
        <a href="mailto:info@selamatmitrajaya.co.id" className="hover:text-white">
          info@selamatmitrajaya.co.id
        </a>
      </footer>
    </div>
  );
};

export default LandingPage;
